module.exports = __webpack_public_path__ + "img/SprayPainting1.f1f83753.jpg";